import { arrayOf, shape, string } from "prop-types";

import FiltersFieldsetWrapper from "../Wrapper/wrapper";
import Location from "./location";

const Container = ({ title, options }) => {
  return (
    <FiltersFieldsetWrapper title={title}>
      <Location options={options} />
    </FiltersFieldsetWrapper>
  );
};
Container.propTypes = {
  title: string.isRequired,
  options: arrayOf(shape({})).isRequired,
};

export default Container;
